import { render, staticRenderFns } from "./VoiceOverScript.vue?vue&type=template&id=331000ed&scoped=true&"
import script from "./VoiceOverScript.vue?vue&type=script&lang=js&"
export * from "./VoiceOverScript.vue?vue&type=script&lang=js&"
import style0 from "./VoiceOverScript.vue?vue&type=style&index=0&id=331000ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331000ed",
  null
  
)

export default component.exports